import { render } from "./FigmaPlugin.vue?vue&type=template&id=7d287cde&scoped=true"
import script from "./FigmaPlugin.vue?vue&type=script&lang=js"
export * from "./FigmaPlugin.vue?vue&type=script&lang=js"

import "./FigmaPlugin.vue?vue&type=style&index=0&id=7d287cde&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d287cde"]])

export default __exports__